import { Calendar, LayoutTemplate, ListTodo } from "lucide-react";
import React from "react";
import { cn } from "../../lib/utils";

export type ViewType = "DiaryTab" | "FloorplanTab" | "RunsheetTab";

interface EDSViewTabsProps {
  selectedView: ViewType;
  onViewChange: (view: ViewType) => void;
  showFloorplan?: boolean;
}

const EDSViewTabs: React.FC<EDSViewTabsProps> = ({
  selectedView,
  onViewChange,
  showFloorplan = true
}) => {
  const tabs = [
    {
      id: "DiaryTab" as const,
      label: "Diary",
      icon: Calendar,
      show: true
    },
    {
      id: "FloorplanTab" as const,
      label: "Floorplan",
      icon: LayoutTemplate,
      show: showFloorplan
    },
    {
      id: "RunsheetTab" as const,
      label: "Run sheet",
      icon: ListTodo,
      show: true
    }
  ].filter((tab) => tab.show);

  return (
    <div className="eds-view-tabs inline-flex items-center">
      <div
        className="eds-view-tabs__container"
        role="tablist"
        aria-label="View options"
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = selectedView === tab.id;

          return (
            <React.Fragment key={tab.id}>
              <button
                onClick={() => onViewChange(tab.id)}
                className={cn(
                  "eds-view-tabs__tab",
                  isActive && "eds-view-tabs__tab--active"
                )}
                role="tab"
                title={tab.label}
                aria-label={tab.label}
                aria-selected={isActive}
                aria-controls={`tabpanel-${tab.id}`}
              >
                <Icon className="eds-view-tabs__icon" />
              </button>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default EDSViewTabs;
